import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/auth/AuthContext";
import { ApiError } from "@/api/client";
import { router } from "@/routes";
import "@/ui/base.css";

const queryClient = new QueryClient({
  defaultQueries: undefined,
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 2,
      refetchOnWindowFocus: true,
    },
  },
} as ConstructorParameters<typeof QueryClient>[0]);

const root = createRoot(document.getElementById("root")!);

// на адресе admin.* открывается админка (docs/ADMIN.md): отдельный кусок сборки, сайту
// она не мешает и в его загрузку не попадает
if (location.hostname.startsWith("admin.")) {
  void import("@/admin/AdminApp").then(({ default: AdminApp }) =>
    root.render(
      <StrictMode>
        <AdminApp />
      </StrictMode>,
    ),
  );
} else {
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
}
